var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"color":"ddblue","size":"120","width":"6","absolute":"","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }